import { render, staticRenderFns } from "./EmailLink.vue?vue&type=template&id=46cff464"
import script from "./EmailLink.vue?vue&type=script&lang=js"
export * from "./EmailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports